module.exports = __webpack_public_path__ + "static/img/306_TO8_2289.28a51b4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/306_TO8_2289.jpg
// module id = Uf2G
// module chunks = 0